<template>
    <div>
        <Pivot :statisticData="statisticData" :filters="filters" :rows="rows" :values="values" :favourites="favourites"
               :filter-default-values="filterDefaultValues" title="Marketing Activities"></Pivot>
    </div>
</template>

<script>
import axios from 'axios'
import Pivot from '../../components/sandoz/Pivot.vue'

export default {

    data: () => ({
        statisticData: [],
        filters: [
            'language',
            'contract_status_combined',
            'year',
            'type',
            'product_group',
            'responsible_sales_person',
            'region'
        ],
        rows: [
            'contract_status_combined',
            'language',
            'marketing_activity_name'
        ],
        values: [
            {
                field: 'quantity',
                function: 'sum'
            },
            {
                field: 'contract_no',
                function: 'count_unique'
            },
            {
              field: 'price',
              function: 'sum'
            }
        ],
        favourites: [
            {
                name: 'Favourite 1',
                filters: [
                  'language',
                  'contract_status'
                ],
                rows: [
                  'contract_status',
                  'language'
                ],
                values: [
                    {
                        field: 'quantity',
                        function: 'sum'
                    }
                ]
            },
            {
                name: 'Favourite 2',
                filters: [
                    'contract_status',
                    'year'
                ],
                rows: [
                    'year',
                    'type'
                ],
                values: [
                    {
                        field: 'contract_no',
                        function: 'count_unique'
                    },
                    {
                        field: 'price',
                        function: 'sum'
                    }
                ]
            }
        ],
        filterDefaultValues: [
            {
                year: new Date().getFullYear() // Pass string if single or array if multiple values
            }
        ]
    }),

    components: {
        Pivot
    },

    mounted() {
        axios.get('/api/sandoz/statistics/marketing_activities').then((response) => {
            this.statisticData = response.data
        })
    }
}
</script>
